import { Link, router, usePage } from "@inertiajs/react";
import { Eye } from "lucide-react";

/**
 * Shown on every page to anyone signed in to a demo account, and on the
 * demo school's public pages, so nobody mistakes it for a real school.
 * Rendered from inertiaApp.jsx, like the impersonation banner.
 */
export default function DemoBanner() {
  const { demo, routes } = usePage().props;

  if (!demo) return null;

  return (
    <div className="relative z-[90] border-b border-info/20 bg-info/10 text-foreground">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 text-sm">
        <span className="flex items-center gap-2 font-medium">
          <Eye className="h-4 w-4 shrink-0 text-info" aria-hidden="true" />
          {demo.signed_in
            ? "You're exploring a demo school. Look around: nothing you change is saved."
            : "This is a demo school. Donations here are pretend, and no card is charged."}
        </span>
        <span className="flex items-center gap-4">
          <Link href={routes.demo} className="font-semibold underline underline-offset-2 hover:no-underline">
            {demo.signed_in ? "Switch role" : "Try the staff view"}
          </Link>
          {demo.signed_in && (
            <button type="button" onClick={() => router.delete(routes.demo)} className="font-semibold underline underline-offset-2 hover:no-underline">
              {demo.real_account ? "Back to your account" : "Exit demo"}
            </button>
          )}
          <Link href={routes.new_school_application} className="font-semibold text-primary underline underline-offset-2 hover:no-underline">
            Sign up your school
          </Link>
        </span>
      </div>
    </div>
  );
}
